import { mountVueComponent } from '@/lib/mount-vue-component';

export default () =>
	import('@/modules/role/component/RoleForm.vue').then((roleForm) => mountVueComponent('role-form', roleForm));
